//
//
//
//
//
//
//
//

export default {
    props: {
        persistent: {
            type: Boolean,
            default: false,
        },
        /** @type {import('vue').PropOptions<TIDAL.UserInfo>} */
        userInfo: {
            type: Object,
            required: true,
        },
    },
};
